import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
} from 'react';

import './animation044.less';
import { usePlayFlag } from '../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation044Item {
  text: string;
  linkDetail?: IHyperLinkItem;
}

interface IHyperLinkItem {
  label: string;
  linkText: string;
  link?: string;
}

interface IAnimation044Props {
  items: IAnimation044Item[];
  className?: string | null;
  onCompleted: () => void;
}

const Animation044: FunctionComponent<IAnimation044Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);

  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation044 onCompleted');
      onCompleted && onCompleted();
    }
  };

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };
  return (
    <div ref={crrRef} className={`animation044 component ${className}`}>
      <div className="animation044-content">
        {items.map((itm: IAnimation044Item, idx: number) => (
          <div
            key={idx}
            className={`animation044-item r${idx + 1} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <div className="animation044-position">
              <img
                className="click-point"
                onClick={() => clickToPlay()}
                style={{
                  display: play <= 1 ? 'block' : 'none',
                }}
                src={ImgPoint}
                alt=""
              />
              <div className="animation044-subcontent">
                <div className="animation044-indicator">0{idx + 1}</div>
                <div className="animation044-body">
                  <span
                    className="animation044-text"
                    dangerouslySetInnerHTML={{ __html: itm.text }}
                  />
                  {itm.linkDetail && (
                    <span className="linkDetail">
                      （{itm.linkDetail.label}
                      <a
                        href={itm.linkDetail.link}
                        key={`link${idx}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {itm.linkDetail.linkText}
                      </a>
                      ）
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation044;
